import { createTheme, rem } from '@mantine/core';
import components from './components';

/**
 * Extended Mantine theme.
 * @see {@link https://mantine.dev/theming/theme-object/}
 */
export const theme = createTheme({
  colors: {
    dark: [
      '#e8e8ea',
      '#d0d1d4',
      '#b9b9bf',
      '#a1a2a9',
      '#8a8b94',
      '#73747e',
      '#5b5d69',
      '#444553',
      '#2c2e3e',
      '#151728',
    ],
    gray: [
      '#F9FAFB',
      '#F2F4F7',
      '#EAECF0',
      '#D0D5DD',
      '#98A2B3',
      '#667085',
      '#475467',
      '#344054',
      '#1D2939',
      '#101828',
    ],
    blue: [
      '#EEF4FF',
      '#E0EAFF',
      '#C7D7FE',
      '#A4BCFD',
      '#8098F9',
      '#6172F3',
      '#444CE7',
      '#3538CD',
      '#2D31A6',
      '#2D3282',
    ],
    green: [
      '#ECFDF3',
      '#D1FADF',
      '#A6F4C5',
      '#6CE9A6',
      '#32D583',
      '#12B76A',
      '#039855',
      '#027A48',
      '#05603A',
      '#054F31',
    ],
    orange: [
      '#FFFAEB',
      '#FEF0C7',
      '#FEDF89',
      '#FEC84B',
      '#FDB022',
      '#F79009',
      '#DC6803',
      '#B54708',
      '#93370D',
      '#7A2E0E',
    ],
    red: [
      '#FEF3F2',
      '#FEE4E2',
      '#FECDCA',
      '#FDA29B',
      '#F97066',
      '#F04438',
      '#D92D20',
      '#B42318',
      '#912018',
      '#7A271A',
    ],
  },

  other: {
    lightColors: {
      gray: '#FCFCFD',
      blue: '#F5F8FF',
      green: '#F6FEF9',
      orange: '#FFFCF5',
      red: '#FFFBFA',
    },
  },

  primaryColor: 'dark',
  primaryShade: 9,

  defaultRadius: 8,

  fontFamily: 'Inter, sans-serif',
  headings: {
    sizes: {
      h1: {
        fontSize: '36px',
        lineHeight: '44px',
        fontWeight: '600',
      },
      h2: {
        fontSize: '30px',
        lineHeight: '38px',
        fontWeight: '600',
      },
      h3: {
        fontSize: '24px',
        lineHeight: '32px',
        fontWeight: '600',
      },
      h4: {
        fontSize: '20px',
        lineHeight: '30px',
        fontWeight: '600',
      },
    },
  },

  spacing: {
    xs: rem(4),
    sm: rem(8),
    s: rem(10),
    md: rem(12),
    lg: rem(18),
    xl: rem(24),
  },

  components,
});
